import axios from 'axios';
import * as types from '@/store/mutation-types';
import {performApiRequest} from '@/store/helpers/vuex-helpers';
import type {BookingState} from '@/store/modules/booking';


export interface FleetAppState {
    loading: Record<string, boolean>;
    dialogs: Record<string, boolean>;
}

// state
const state: FleetAppState = {
    loading: {
        setMailchimpMailingList: false,
        getMailchimpMailingLists: false,
    },
    dialogs: {
        appInstalledSuccessDialog: false
    },
};

const getters = {
    loading: (state: FleetAppState) => state.loading,
    dialogs: (state: FleetAppState) => state.dialogs,
};

const mutations = {
    [types.SET_FLEET_APP_LOADING](state: FleetAppState, loading: { subject: string, loading: boolean }) {
        state.loading[loading.subject] = loading.loading;
    },
    [types.SET_FLEET_APP_LOADING_DIALOG](state: BookingState, dialog: { subject: string, value: boolean }) {
        state.dialogs[dialog.subject] = dialog.value;

        setTimeout(() => {
            state.dialogs[dialog.subject] = false;
        }, 500);
    },
};

const actions = {

    async getMailchimpMailingLists({commit}, payload) {
        return await performApiRequest(commit, 'SET_FLEET_APP_LOADING', 'getMailchimpMailingLists', () => axios.get(`/v1/fleet-app-subscriptions/${payload.fleetAppSubscriptionId}/getMailchimpMailingLists`));
    },

    async setMailchimpMailingList({commit}, payload) {
        return await performApiRequest(commit, 'SET_FLEET_APP_LOADING', 'setMailchimpMailingList', () => axios.post(`/v1/fleet-app-subscriptions/${payload.fleetAppSubscriptionId}/setMailchimpMailingList`, payload));
    },

    async getMailchimpOAuthUrl({commit}) {
        return await performApiRequest(commit, 'SET_FLEET_APP_LOADING', 'setMailchimpMailingList', () => axios.get(`/v1/mailchimp/oauth-url`));
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
